import React, { useEffect, useState } from 'react'
import { Container } from './styles'
import { FilterPerTypeCheckboxRow } from '~/components/shared'
import { IconComponent } from '~/assets/icons/component'
import { HealthProcedureVariantProps } from '~/constants'

export interface FilterType {
  text: string
  type: string[]
  subTypes?: FilterType[]
  isActive?: boolean
}

interface PopoverFilterTypeProps {
  setTypes: (filterType: FilterType[]) => void
  filterTypes: FilterType[]
  checkedTypes: string[]
}

export const PopoverFilterType = ({ setTypes, filterTypes, checkedTypes }: PopoverFilterTypeProps): JSX.Element => {
  const [showContainer, setShowContainer] = useState({})
  const [filters, setFilters] = useState<FilterType[]>([])

  useEffect(() => {
    const typesAlreadyChecked = filterTypes.filter(item => checkedTypes?.includes(item.type[0]))
    setFilters(typesAlreadyChecked)
  }, [checkedTypes, filterTypes])

  const handleShowContainer = idUL => {
    setShowContainer({ ...showContainer, [idUL]: !showContainer[idUL] })
  }

  const handleSelectFilter = (type: string[], isActive: boolean, text: string) => {
    const newFilter = { text, type, isActive }
    const newSelectedFilters = isActive ? addFilter(newFilter) : removeFilter(newFilter)

    setTypes(newSelectedFilters)
    setFilters(newSelectedFilters)
  }

  const removeFilter = (filter: FilterType): FilterType[] => {
    const newFilters = filters.filter(currentFilter => !currentFilter.text.includes(filter.text))
    return newFilters
  }

  const addFilter = (filter: FilterType): FilterType[] => {
    const newFilters = [...filters, { type: filter.type, text: filter.text }]
    return newFilters
  }

  const renderTypesOptions = () => {
    if (filterTypes && filterTypes.length > 0) {
      return filterTypes.map((item, index) => {
        const filterOption = item.type[0]
        const isChecked = checkedTypes?.includes(filterOption)

        return (
          <li key={index}>
            <FilterPerTypeCheckboxRow
              index={`checkBox${index}-${item.text}`}
              color={HealthProcedureVariantProps[filterOption]?.color}
              text={item.text}
              Icon={() => <IconComponent name={HealthProcedureVariantProps[filterOption]?.iconName} />}
              type={item.type}
              onChange={handleSelectFilter}
              checked={isChecked}
            />
            {item.subTypes && (
              <button
                style={{ transform: !showContainer[`idUl-${index}`] ? '' : 'rotate(180deg)' }}
                data-testid={`subTypeButton-${item.text}`}
                onClick={() => handleShowContainer(`idUl-${index}`)}
              >
                <IconComponent name="chevronDown" />
              </button>
            )}
            {item.subTypes && renderSubTypesOptions(item.subTypes, filterOption, `idUl-${index}`, checkedTypes)}
          </li>
        )
      })
    }
  }

  const renderSubTypesOptions = (subTypes: FilterType[], mainType: string, idUl: string, checkedTypes: string[]) => {
    if (subTypes && subTypes.length > 0) {
      return (
        <ul
          className="subTypes"
          style={{ display: showContainer[idUl] ? 'flex' : 'none' }}
          data-testid={`subTypeList-${mainType}`}
        >
          {subTypes.map((item, index) => {
            const subTypeOption = item.type[0]
            const subItemIdentifier = `${mainType}-${subTypeOption}`
            const isChecked = checkedTypes?.includes(subItemIdentifier)

            return (
              <li key={index}>
                <FilterPerTypeCheckboxRow
                  index={`subType${index}-${mainType}`}
                  color={HealthProcedureVariantProps[subTypeOption]?.color}
                  text={item.text}
                  Icon={() => <IconComponent name={HealthProcedureVariantProps[subTypeOption]?.iconName} />}
                  type={item.type}
                  onChange={(type, checked, text) => handleSelectFilter([subItemIdentifier], checked, text)}
                  checked={isChecked}
                />
                {item.subTypes && (
                  <button
                    style={{ transform: !showContainer[idUl] ? 'rotate(180deg)' : '' }}
                    onClick={handleShowContainer}
                  >
                    &circ;
                  </button>
                )}
                {item.subTypes && renderSubTypesOptions(item.subTypes, subTypeOption, `idUl-${index}`, checkedTypes)}
              </li>
            )
          })}
        </ul>
      )
    }
  }

  return (
    <Container>
      <ul>{renderTypesOptions()}</ul>
    </Container>
  )
}
